import CodeButtons from "shared/code_buttons";
import * as React from 'react';
export default {
  CodeButtons,
  React
};